import CreateIcon from '@mui/icons-material/Create';
import { Chip, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';
import React from 'react';

export const DietList: React.FC<{
  title: string;
  diets: string[];
  selectedPreferences: string[];
  onToggle: (key: string) => void;
  dietToName: { [key: string]: string };
  onEdit: () => void;
}> = ({ diets, selectedPreferences, onToggle, dietToName, onEdit }) => {
  const theme = useTheme();
  const useStyles = makeStyles(() => ({
    chipEnabled: {
      color: theme.palette.primary.dark,
      height: 48,
      borderRadius: 30,
      padding: 10,
      fontSize: 15,
      backgroundColor: theme.palette.primary.main.concat('26'),
      border: '1px solid '.concat(theme.palette.primary.main, '26')
    },

    chipDisabled: {
      border: '1px solid '.concat(theme.palette.info.light),
      color: theme.palette.info.light,
      height: 48,
      borderRadius: 30,
      padding: 10,
      fontSize: 15,
      background: theme.palette.grey[0],
      fontWeight: 'normal',
    },
  }));

  const classes = useStyles();

  return (
    <Stack direction='row' alignItems='center'>
      
      <Stack
        direction='row'
        flex={1}
        sx={{
          overflowY: 'scroll',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
        textAlign='start'
      >
        {diets.map((key) => (
          <Chip
            key={key}
            className={clsx({
              [classes.chipEnabled]: selectedPreferences.includes(key),
              [classes.chipDisabled]: !selectedPreferences.includes(key),
            })}
            sx={{
              mr: 1,
              mb: 1,
            }}
            label={dietToName[key]}
            onClick={(_) => onToggle(key)}
          />
        ))}
      </Stack>
      <IconButton sx={{
        maxWidth: '20px',
        maxHeight: '20px',
        backgroundColor: '#131313',
        borderRadius: '50%',
        cursor:'hand'
      }} onClick={onEdit}>
        <CreateIcon
            style={{color: 'white', maxWidth: '15px'}}
          />
      </IconButton>
    </Stack>
  );
};
